import * as React from 'react'
import * as styles from './CardOverlay.module.scss'


interface CardOverlayProps {
    content: React.ReactChild
    children: React.ReactChild | React.ReactChild[]
    onMouseLeave:  (event: React.MouseEvent<HTMLDivElement>) => void
}

export class CardOverlay extends React.Component<CardOverlayProps> {

    render() {
        return (
            <div className={styles.cardOverlay} onMouseLeave={this.props.onMouseLeave}>
                <div className={styles.cardOverlayContentWrapper}>
                    <div className={styles.cardOverlayContent}>
                        {this.props.content}
                    </div>
                </div>
                <div className={styles.isolate}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}